import { useEffect } from 'react';

import { useTagState, useTagActions } from './TagContext';

import { getTag } from './restApi';

const TagLoader = ({ id }) => {
  const state = useTagState();
  const { initializeState, onResponse, onError } = useTagActions();

  useEffect(() => {
    initializeState(id);
  }, []);

  useEffect(() => {
    if (state?.tag?.id) {
      getTag({
        onResponse,
        onError,
        id: state.tag.id,
      });
    }
  }, [state?.tag?.id]);

  return null;
};

export default TagLoader;
